import {css} from '@yandex-delivery/blocks/theme/css'

export const input = css`
  &:before {
    content: none;
  }
`
export const mapTrail = css`
  inline-size: auto;
`
